import React, { JSX } from 'react';
import DataExplorerControls from './DataExplorerControls';
import DataExplorerTable from './DataExplorerTable';
import type { DataExplorerPaneProps } from '../types/DataExplorerPaneTypes';

export default function DataExplorerPane(props: DataExplorerPaneProps): JSX.Element {
  const {
    isAdmin,
    dataset,
    onDatasetChange,
    deviceIdSearch,
    onDeviceIdSearchChange,
    athleteAssignmentsRaceSearch,
    onAthleteAssignmentsRaceSearchChange,
    explorerBusy,
    explorerBackfillBusy = false,
    explorerScanCapped = false,
    onRefresh,
    onDownloadCsv,
    hasAnyRows,
    filteredExplorerRows,
    explorerRows,
    explorerColumns,
    userEmailBySub,
    deviceIdColumn,
    onRemoveRow,
  } = props;

  return (
    <section className="h-full min-h-0 flex flex-col rounded-xl border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-sm overflow-hidden">
      <DataExplorerControls
        isAdmin={isAdmin}
        dataset={dataset}
        onDatasetChange={onDatasetChange}
        deviceIdSearch={deviceIdSearch}
        onDeviceIdSearchChange={onDeviceIdSearchChange}
        athleteAssignmentsRaceSearch={athleteAssignmentsRaceSearch}
        onAthleteAssignmentsRaceSearchChange={onAthleteAssignmentsRaceSearchChange}
        explorerBusy={explorerBusy}
        onRefresh={onRefresh}
        onDownloadCsv={onDownloadCsv}
        hasAnyRows={hasAnyRows}
      />

      {(explorerBackfillBusy || explorerScanCapped) && (
        <div
          className="shrink-0 border-b border-amber-200 bg-amber-50 px-4 py-2 text-[11px] text-amber-950 dark:border-amber-700/60 dark:bg-amber-950/40 dark:text-amber-100"
          role="status"
        >
          {explorerBackfillBusy && (
            <span>
              Loading additional rows from DynamoDB… ({explorerRows.length.toLocaleString()} loaded so far)
            </span>
          )}
          {!explorerBackfillBusy && explorerScanCapped && (
            <span>
              Stopped at {explorerRows.length.toLocaleString()} rows (safety limit). Use the search boxes to narrow
              results, or export CSV for what is loaded.
            </span>
          )}
        </div>
      )}

      <DataExplorerTable
        dataset={dataset}
        explorerBusy={explorerBusy}
        deviceIdSearch={deviceIdSearch}
        filteredExplorerRows={filteredExplorerRows}
        explorerRows={explorerRows}
        explorerColumns={explorerColumns}
        userEmailBySub={userEmailBySub}
        deviceIdColumn={deviceIdColumn}
        onRemoveRow={onRemoveRow}
      />
    </section>
  );
}
